import React from 'react'

export const CommunicationIcon = ({
   width = 21,
   height = 21,
   color = 'white',
   opacity = 0.7,
   ...props
}: React.SVGProps<SVGSVGElement> & { color?: string; opacity?: number }) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      {...props}
   >
      <g opacity={opacity}>
         <path
            d="M7.99858 13.8254C10.6289 13.6793 12.7168 11.5002 12.7168 8.83334C12.7168 6.07191 10.4782 3.83334 7.7168 3.83334C4.95537 3.83334 2.7168 6.07191 2.7168 8.83334C2.7168 9.81726 3.00091 10.7348 3.4917 11.5083L3.13835 12.5684L3.13778 12.5699C3.00244 12.976 2.93474 13.1791 2.98295 13.3142C3.02496 13.432 3.1182 13.5249 3.236 13.5669C3.37073 13.615 3.57242 13.5477 3.97571 13.4133L3.98145 13.4115L5.04183 13.0582C5.81538 13.549 6.73292 13.8332 7.71685 13.8332C7.81139 13.8332 7.90533 13.8306 7.99858 13.8254ZM7.99858 13.8254C7.99865 13.8256 7.99851 13.8252 7.99858 13.8254ZM7.99858 13.8254C8.68269 15.7716 10.5369 17.1668 12.7169 17.1668C13.7008 17.1668 14.6182 16.8824 15.3917 16.3915L16.4518 16.7449L16.4539 16.7453C16.8599 16.8806 17.0633 16.9484 17.1985 16.9002C17.3163 16.8582 17.4084 16.7654 17.4504 16.6476C17.4986 16.5122 17.4311 16.3088 17.2954 15.9017L16.9421 14.8416L17.0604 14.6455C17.4783 13.915 17.7163 13.0686 17.7163 12.1667C17.7163 9.40525 15.4782 7.16667 12.7168 7.16667L12.5296 7.17012L12.4352 7.17473"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </g>
   </svg>
)
